/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Initial_Role_EnabledInputs */

const en_admin_settings_fields_initial_role_enabled = /** @type {(inputs: Admin_Settings_Fields_Initial_Role_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-assign role for new users`)
};

/**
* | output |
* | --- |
* | "Auto-assign role for new users" |
*
* @param {Admin_Settings_Fields_Initial_Role_EnabledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_initial_role_enabled = /** @type {((inputs?: Admin_Settings_Fields_Initial_Role_EnabledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Initial_Role_EnabledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_initial_role_enabled(inputs)
});
export { admin_settings_fields_initial_role_enabled as "admin.settings.fields.initial_role_enabled" }